import AprobarPermisosPersonalGerencia from "../../Screen/Gerencia/Permisos/AprobarPermisosPersonalGerencia";
import AutorizarRequisasMantenimientoScreen from "../../Screen/Mantenimiento/Requisas/AutorizarRequisasMantenimientoScreen";
import QRMarcajeScreen from "../../Screen/RRHH/Marcaje/QRMarcajeScreen";
import OrganigramaScreen from "../../Screen/RRHH/Organigrama/Organigrama/OrganigramaScreen";
import ListadoPermisosPersonalRRHH from "../../Screen/RRHH/Permisos/Taps/ListadoPermisosPersonalRRHH";
import ListadoPermisosRRHH from "../../Screen/RRHH/Permisos/Taps/ListadoPermisosRRHH";
import OrganigramaDepartamentoScreen from "../../Screen/RRHH/Organigrama/OrganigramaDepartamento/OrganigramaDepartamentoScreen";
import OrganigramaCamden from "../../Screen/RRHH/Organigrama/Camden/OrganigramaCamden";
import EvaluacionPersonalList from "../../Screen/RRHH/Evaluacion/EvaluacionPersonalList";
import EvaluacionPersonalScreen from "../../Screen/RRHH/Evaluacion/EvaluacionPersonalScreen";


export const RRHHRoutes = [
  {
    path: 'RRHH/PermisosRH',
    permiso: 60,
    element: <AprobarPermisosPersonalGerencia permiso={2} /> // 2 = RH RRHH
  },
  {
    path: 'RRHH/QRMarcaje',
    permiso: 33,
    element: <QRMarcajeScreen />,
  },
  {
    path: 'RRHH/AprobarSalidaUniformes',
    permiso: 77,
    element: <AutorizarRequisasMantenimientoScreen />,
  },
  {
    path: 'RRHH/ListadoPermisos',
    permiso: 62,
    element: <ListadoPermisosRRHH />,
  },
  {
    path: 'RRHH/PermisosPersonal',
    permiso: 61,
    element: <ListadoPermisosPersonalRRHH />,
  },
  {
    path: 'RRHH/Organigrama',
    permiso: 28,
    element: <OrganigramaScreen key={'ppf'} />,
  },
  {
    path: 'RRHH/OrganigramaDepartamento',
    permiso: 34,
    element: <OrganigramaDepartamentoScreen />,
  },
  {
    path: 'RRHH/OrganigramaCamden',
    permiso: 31,
    element: <OrganigramaScreen Camden={true}  key={'camden'} />,
  },
  {
    path: 'RRHH/EvaluacionPersonal',
    permiso: 63,
    element: <EvaluacionPersonalList />,
  },
  {
    path: 'RRHH/NewEvaluacionPersonal',
    permiso: 63,
    element: <EvaluacionPersonalScreen />,
  },
  {
    path: 'RRHH/EditEvaluacionPersonal/:IdEvaluacion',
    permiso: 63,
    element: <EvaluacionPersonalScreen />,
  },
];

export default RRHHRoutes;